import * as Dialog from '@radix-ui/react-dialog';
import { AppWindowMac } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { type ChatHistoryItem } from '~/lib/persistence';

interface HistoryItemProps {
  item: ChatHistoryItem;
  onDelete?: (event: React.UIEvent) => void;
}

export function HistoryItem({ item, onDelete }: HistoryItemProps) {
  const [hovering, setHovering] = useState(false);
  const hoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;

    function mouseEnter() {
      setHovering(true);

      if (timeout) {
        clearTimeout(timeout);
      }
    }

    function mouseLeave() {
      setHovering(false);
    }

    hoverRef.current?.addEventListener('mouseenter', mouseEnter);
    hoverRef.current?.addEventListener('mouseleave', mouseLeave);

    return () => {
      hoverRef.current?.removeEventListener('mouseenter', mouseEnter);
      hoverRef.current?.removeEventListener('mouseleave', mouseLeave);
    };
  }, []);

  return (
    <div
      ref={hoverRef}
      className="group rounded-lg hover:text-alpha-elements-textPrimary bg-alpha-background-tertiary  overflow-hidden flex justify-between items-center px-2 py-2 mb-4"
    >
      <a href={`/chat/${item.urlId}`} className="flex w-full relative truncate text-alpha-fontSize-sm text-white">
        <AppWindowMac className="w-4 h-4 mr-2" />
        <span className="truncate w-40">{item.description}</span>
        <div className="absolute right-0 z-1 top-0 bottom-0  group-hover:from-alpha-elements-background-depth-3  w-10 flex justify-end group-hover:w-15 group-hover:from-45%">
          {hovering && (
            <div className="flex items-center p-1 text-alpha-elements-textSecondary hover:text-alpha-elements-item-contentDanger">
              <Dialog.Trigger asChild>
                <button
                  className="i-ph:trash scale-110 ml-1"
                  onClick={(event) => {
                    // we prevent the default so we don't trigger the anchor above
                    event.preventDefault();
                    onDelete?.(event);
                  }}
                />
              </Dialog.Trigger>
            </div>
          )}
        </div>
      </a>
    </div>
  );
}
